"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppliedVoucherTypes = void 0;
var AppliedVoucherTypes;
(function (AppliedVoucherTypes) {
    AppliedVoucherTypes["GIFT"] = "GIFT";
    AppliedVoucherTypes["GENERIC_DISCOUNT"] = "GENERIC_DISCOUNT";
    AppliedVoucherTypes["UNIQUE_DISCOUNT"] = "UNIQUE_DISCOUNT";
    AppliedVoucherTypes["PAYBACK"] = "PAYBACK";
    AppliedVoucherTypes["CREDIT"] = "CREDIT";
    AppliedVoucherTypes["DV"] = "DV";
})(AppliedVoucherTypes || (exports.AppliedVoucherTypes = AppliedVoucherTypes = {}));
//# sourceMappingURL=VoucherEnums.js.map